module.exports = __webpack_public_path__ + "img/school_tysyzx.7ddd23af.png";